<template>
    <div class="footer--background divider--container">
        <div class="container mx-auto flex items-center justify-center px-2">
            <div class="w-full md:w-1/2 text-center">
                <h2 v-if="footerType.title" class="pt-5 pb-4">
                    {{ footerType.title }}
                </h2>
                <p v-if="footerType.text" class="pt-1 pb-4">
                    {{ footerType.text }}
                </p>

                <faq-search-footer
                    v-if="footerType.searchBar"/>

                <faq-sub-footer
                    v-if="footerType.faqItems"
                    :faqItems="footerType.faqItems"/>

                <got-more-questions
                    v-if="footerType.gotMoreQuestions"/>

            </div>
        </div>
        <div class="text-left py-10">
            <contact-us
                v-if="footerType.contactUs"
                :faqsLink="footerType.faqsLink"/>
        </div>
    </div>
</template>
<script>
import ContactUs from '@/components/structure/navigation/navigation/ContactUs';
import FaqSearchFooter from '@/components/partials/faq/FaqSearchFooter';
import FaqService from '@/services/faq/FaqService';
import FaqSubFooter from '@/components/partials/faq/FaqSubFooter';
import GotMoreQuestions from '@/components/structure/navigation/navigation/GotMoreQuestions';

export default {
    name: 'Footer',
    components: {
        ContactUs,
        FaqSearchFooter,
        GotMoreQuestions,
        FaqSubFooter,
    },
    props: {
        pageName: {
            type: String,
            required: true,
            default: 'login',
        },
    },
    data() {
        return {
            help: {
                title: this.$t(''), // HAMBURGER_HELP is removed for new footer. Title can be added here if needed in future.
                text: '',
                faqsLink: true,
                contactUs: true,
            },
            esoteric: {
                title: this.$t('FOOTER_GOT_SOMETHING'),
                text: this.$t('FOOTER_GOT_HOWEVER'),
                contactUs: true,
            },
            faqSearch: {
                searchBar: true,
                contactUs: true,
            },
            signUp: {
                page: null,
                gotMoreQuestions: true,
                faqItems: [],
            },
        };
    },
    watch: {
        'signUp.page'() {
            this.faqItems();
        },
    },
    computed: {
        footerType() {
            const map = new Map([
                ['login', this.help],
                ['faq.categories', this.esoteric],
                ['faq.answers', this.faqSearch],
                ['register.account', this.signUp, this.signUp.page = this.pageName],
                ['register.delivery', this.signUp, this.signUp.page = this.pageName],
                ['register.card-details', this.signUp, this.signUp.page = this.pageName],
            ]);

            return map.get(this.pageName) || map.get('login');
        },
    },
    methods: {
        faqItems() {
            if (this.pageName.includes('register')) {
                const faqService = new FaqService();
                const map = new Map([
                    ['register.account', faqService.getIntroductionsQuestions()],
                    ['register.delivery', faqService.getDeliveryQuestions()],
                    ['register.card-details', faqService.getPaymentQuestions()],
                ]);
                map.get(this.pageName).then(response => {
                    this.signUp.faqItems = response;
                    return response;
                });
            };
        },
    },
};
</script>
